<template>
    <div class="g-h100 activity-detail">
        <div class="a">
            <div class="b"></div>
            <div class="box">
                <div class="title" >
                    {{ detailsInfos.name }}
                </div>
                <div class="time" v-if="detailsInfos.timeType === 0">活动时间: 每月{{ detailsInfos.startDay }}日至{{ detailsInfos.endDay }}日</div>
                <div class="time" v-if="detailsInfos.timeType === 1">活动时间: {{ detailsInfos.startDate }} 至 {{ detailsInfos.endDate }}</div>
                <div class="card-wrap">
                    <div class="card" v-for="i in detailsInfos.rights" :key="i">
                        <div class="i1"></div>
                        <div class="i2"></div>
                        <p class="i3">
                            <span class="i6">{{ i.value }}</span>
                            <span class="i7">{{ i.name === '消费折扣' ? '折' : '分' }}</span>
                        </p>
                        <p class="i4">{{ i.name }}</p>
                        <div class="i5">
                            <p class="i5-1">{{ i.levelName }}</p>
                        </div>
                    </div>
                </div>
                <div style="height: 1px"></div>
            </div>

            <div class="box mt">
                <div class="title" >活动介绍</div>
                <div class="content" v-html="detailsInfos.introduction"></div>
                <div style="height: 1px"></div>
            </div>

            <div class="footer">活动最终解释权归「{{ companyName }}」所有</div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'MemberActivityDetails',
    data () {
        return {
            pageTitle: '活动详情',
            id: this.$vxRoute.query.id,
            companyId: this.$vxRoute.query.companyId,
            companyName: this.$vxRoute.query.companyName,
            detailsInfos: {},
        }
    },
    created() {
        this.showLoading();
        let {id,companyId} = this;
        this.$api.getMemberActivityById({ id,companyId }).then(res => {
            if (res.code === 200) {
                this.$toast.clear();
                this.detailsInfos= res.data;
                this.detailsInfos.rights = []
                res.data && res.data.levelList && res.data.levelList.forEach(item => {
                    if (item.status === 0) {
                        if (item.discount > 0) {
                            detailsInfos.rights.push({
                                levelName: item.levelName,
                                name: '消费折扣',
                                value: item.discount
                            })
                        }
                        if (item.givePoint > 0) {
                            detailsInfos.rights.push({
                                levelName: item.levelName,
                                name: '赠送积分',
                                value: item.givePoint
                            })
                        }
                    }
                })
            } 
        })
    }
}



</script>

<style lang="scss" scoped>
.g-h100 {
    height: 100%;
}
p{
    margin: 0;
}
.activity-detail {
    background-color: #d42913;
    overflow: auto;
    .a {
        background-size: 100% auto;
        min-height: 100%;
        background-repeat: no-repeat;
        background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/activity-detail-bg.png);
        .b {
            height: 330px;
        }
        .mt {
            margin-top: 27px !important;
        }
        .box {
            margin: 0 16px;
            background-color: #f85037;
            min-height: 200px;
            border-radius: 12px;
            .title {
                height: 40px;
                margin: 0 30px;
                background-size: 100% 100%;
                position: relative;
                top: -7px;
                text-align: center;
                font-size: 18px;
                font-weight: 600;
                color: #ff3301;
                line-height: 40px;
                padding: 0 20px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/activity-detail-title.png);
            }
            .time {
                margin-top: 13px;
                color: #fff1e0;
                font-size: 12px;
                text-align: center;
            }
            .card-wrap {
                margin: 20px 2px 10px 12px;
                display: grid;
                grid-template-columns: repeat(3, 33.33%);
                .card {
                    height: 116px;
                    background: linear-gradient(180deg, #fdf1d9 0%, #fbd1a5 100%);
                    border-radius: 12px;
                    margin-bottom: 10px;
                    margin-right: 10px;
                    position: relative;
                    overflow: hidden;
                    color: #ff3301;
                    text-align: center;
                    .i1,
                    .i2 {
                        position: absolute;
                        top: 55px;
                        width: 20px;
                        height: 20px;
                        background-color: #f85037;
                        border-radius: 50%;
                    }
                    .i1 {
                        left: -10px;
                    }
                    .i2 {
                        right: -10px;
                    }
                    .i3 {
                        margin-top: 10px;
                    }
                    .i4 {
                        font-size: 12px;
                    }
                    .i5 {
                        font-size: 14px;
                        font-weight: 500;
                        border-top: 1px dashed #f85037;
                        margin: 0 20px;
                        padding-top: 5px;
                        margin-top: 5px;
                        height: 46px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .i5-1{
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            line-height: normal;
                        }
                    }
                    .i6 {
                        font-size: 28px;
                        font-weight: 700;
                    }
                    .i7 {
                        font-size: 14px;
                        font-weight: 700;
                    }
                }
            }
            .content {
                padding: 16px 12px 20px 12px;
                color: #fff1e0;
                word-break: break-all;
            }
        }
        .footer {
            padding: 30px 0;
            text-align: center;
            color: #fff1e0;
            font-size: 14px;
        }
    }
}
</style>
